// extracted by mini-css-extract-plugin
module.exports = {"field":"Field_field__3NcNQ","label":"Field_label__2rPVZ"};